import * as React from 'react';
import {Edit, SimpleForm, TextInput, DateInput, required, useRecordContext, useResourceContext} from 'react-admin';
import {CustomToolbar} from '../../components/customtoolbar/customToolbar.component';
import {Box, Grid} from '@mui/material';

export const RiskTemplateEdit = () => {
  const resource = useResourceContext();
  const record = useRecordContext();

  return (
    <Edit
      resource={resource}
      id={record?.id}
      children={
        <SimpleForm
          toolbar={<CustomToolbar noDelete />}
          children={
            <Grid container width="100%" spacing={1}>
              <Grid item xs={8}>
                <Box display="flex">
                  <Box flex={1}>
                    <TextInput source="title" fullWidth validate={[required()]} />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={8}>
                <Box display="flex">
                  <Box flex={1} mr={1}>
                    <DateInput source="createdAt" disabled fullWidth />
                  </Box>
                  <Box flex={1} ml={1}>
                    <DateInput source="updatedAt" disabled fullWidth />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          }
        />
      }
    />
  );
};
